module.exports = __webpack_public_path__ + "static/media/Debentures Hub logo-white.f282799b.svg";